import { useState } from 'react';
import { Dropdown, DropdownItem, DropdownMenu } from 'reactstrap';
import styled from 'styled-components';
import _ from 'lodash';
import IconButton from './basics/IconButton';
import { filterButtonStyles } from './basics/FilterButton';

const StyledMenu = styled(DropdownMenu)`
  max-width: 300px;
  overflow-x: hidden;
  font-size: 13px;
`;

export const FilterButton = styled(({ filterStyles, ...props }) => (
  <IconButton {...props} />
))`
  max-width: 180px;
  overflow-x: hidden;
  ${({ filterStyles = true }) => filterStyles && filterButtonStyles}
`;

const FilterDropdown = ({
  options,
  setOption,
  selectedOption,
  optionsTitle,
  allOptionsTitle = `all ${optionsTitle}s`,
  className,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((open) => !open);
  const optionStrings = options.map((option) =>
    typeof option === 'string' ? option : option.name,
  );
  const selectedOptionValid =
    selectedOption && optionStrings.includes(selectedOption);

  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggle} className={className}>
      <FilterButton toggle size="sm" selected={selectedOptionValid}>
        <span className="text-truncate">
          {selectedOptionValid ? selectedOption : _.capitalize(allOptionsTitle)}
        </span>
      </FilterButton>
      <StyledMenu>
        <DropdownItem header className="font-small">
          Filter by {optionsTitle}
        </DropdownItem>
        {options.map((option) => {
          const optionString =
            typeof option === 'string' ? option : option.name;
          return (
            <DropdownItem
              key={option.id || option}
              onClick={() => setOption(option)}
              className="text-truncate"
              title={optionString}
            >
              <span
                className={
                  optionString === selectedOption ? 'font-weight-bold' : ''
                }
              >
                {optionString}
              </span>
            </DropdownItem>
          );
        })}
        <DropdownItem divider />
        <DropdownItem onClick={() => setOption('')}>
          Show {allOptionsTitle}
        </DropdownItem>
      </StyledMenu>
    </Dropdown>
  );
};

export default FilterDropdown;
